angular.module('ApiUtils.dms.cropData').factory('PlantVarietyListFactory', function ($resource){
    return $resource('/api/farm-management/variety/');
});

